import React from "react";
import "./Module3.css";
import SvgProgressIcon from "./SvgProgressIcon.js";
import ProgressCards from "./ProgressCards";
import { useEffect, useState } from "react";
import CalendlyButton from './components/CalendlyButton';

const Module3 = () => {
  function ResponsiveTitle() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };

      window.addEventListener("resize", handleResize);
      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile ? (
      <h4
        className="text-center fw-bold special-font"
        style={{ letterSpacing: "5px", lineHeight: "24px" }}
      >
        VALOR ESTRATÉGICO DA IMO INVESTIMENTOS
      </h4>
    ) : (
      <h3
        className="text-center fw-bold special-font"
        style={{
          letterSpacing: "8px",
          lineHeight: "32px",
        }}
      >
        VALOR ESTRATÉGICO DA <br /> IMO INVESTIMENTOS
      </h3>
    );
  }

  return (
    <div className="py-5" style={{ backgroundColor: "white" }}>
      <div>
        <ResponsiveTitle />
      </div>

      {/* Parágrafos iniciais aprimorados */}
      <p
        className="text-center mt-5 p-2"
        style={{
          fontSize: "20px",
          letterSpacing: "1.8px",
          color: "#111",
          lineHeight: "30px",
        }}
      >
        Nosso papel vai além de conectar investidores a oportunidades
        imobiliárias de alta rentabilidade.
        <br></br>Somos seus parceiros estratégicos para garantir decisões seguras e
        embasadas.
      </p>
      

      {/* Texto explicativo */}
      <p
        className="container text-start mt-5"
        style={{
          fontSize: "18px",
          letterSpacing: "1.8px",
          color: "#111",
          lineHeight: "28px",
        }}
      >
        <span className="fw-bold" style={{ color: "black" }}>
          Com a IMO Investimentos, você pode focar no que realmente importa:{" "}
        </span>
        escolher o tipo de investimento ideal para seu perfil. Nós
        intermediamos, organizamos e acompanhamos todas as etapas operacionais,
        realizadas por profissionais qualificados, garantindo uma jornada de
        investimento segura e eficiente.
      </p>
      <p
        className="container text-start mt-5"
        style={{
          fontSize: "18px",
          letterSpacing: "1.8px",
          color: "#111",
          lineHeight: "28px",
        }}
      >
        <span className="fw-bold" style={{ color: "black" }}>
          Nós cuidamos de todo o resto:{" "}
        </span>
      </p>

      {/* Check-list aprimorada */}
      <div className="container mt-3">
        <div className="row gy-4">
          <div className="col-sm">
            <ul className="check-list">
              <li>Encontrar o imóvel;</li>
              <li>Elaborar o Projeto de Rentabilidade;</li>
              <li>Legalizar o investimento;</li>
              <li>Viabilizar o Projeto de Arquitetura;</li>
              <li>Contratar Equipe de Obras e Empreiteiros;</li>
              <li>Obras e Reformas;</li>
            </ul>
          </div>
          <div className="col-sm mb-5">
            <ul className="check-list">
              <li>Fiscalização e Coordenação da Obra;</li>
              <li>Controle Financeiro;</li>
              <li>Marketing e Venda do Imóvel;</li>
              <li>Distribuição dos dividendos e reinvestimento;</li>
              <li>Administração de aluguéis dos imóveis de patrimônio;</li>
              <li>Escolha, gerenciamento e suporte aos inquilinos.</li>
            </ul>
          </div>
        </div>
      </div>

      {/* COMO FUNCIONA */}
      <div>
        <h3
          className="text-center fw-bold mt-5 special-font"
          style={{
            letterSpacing: "8px",
            lineHeight: "38px",
            fontSize: "clamp(24px, 5vw, 42px)", // responsivo
          }}
        >
          COMO FUNCIONA
        </h3>

        <p
          className="container text-center mt-5 p-2"
          style={{
            fontSize: "20px",
            letterSpacing: "1.8px",
            color: "#111",
            lineHeight: "30px",
          }}
        >
          A IMO Investimentos atua como curadora e intermediadora de
          oportunidades imobiliárias, conectamos investidores a projetos
          viáveis, seguros e com alto potencial de retorno, operados por
          profissionais experientes do mercado.
        </p>

        <div className="container-fluid mt-4">
          <ProgressCards />
        </div>
      </div>

      {/* Botão final premium
      <div className="d-flex justify-content-center align-items-center">
        <button
          className="btn border-0 mb-3 mt-5 px-5 py-3 fw-bold"
          style={{
            backgroundColor: "#ECA600",
            letterSpacing: "1.8px",
            borderRadius: "50px",
            fontSize: "1rem",
            color: "black",
            transition: "all 0.3s ease",
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = "#f0b000";
            e.target.style.color = "#fff";
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = "#ECA600";
            e.target.style.color = "black";
          }}
        >
          FIQUE LIVRE DE PREOCUPAÇÃO PARA RENTABILIZAR SEU DINHEIRO
        </button>
      </div>
      <div className="mb-4">
        
        <CalendlyButton label="INVISTA COM A IMO" />
      </div> */}

    </div>
  );
};

export default Module3;
